// extracted by mini-css-extract-plugin
module.exports = {"efTabs":"tabs_efTabs__SRanZ"};